import React from 'react';

function Events() {
  return (
    <div>
      <h2 className="text-3xl font-bold mb-4">Events</h2>
      <ul className="list-disc ml-6">
        <li className="mb-4">
          <h3 className="text-xl font-bold">Event 1</h3>
          <p className="text-gray-600">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla euismod felis sed mauris tincidunt aliquam.
          </p>
        </li>
        <li className="mb-4">
          <h3 className="text-xl font-bold">Event 2</h3>
          <p className="text-gray-600">
            Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.
          </p>
        </li>
        <li className="mb-4">
          <h3 className="text-xl font-bold">Event 3</h3>
          <p className="text-gray-600">
            Fusce eu justo nec metus fringilla tincidunt a sit amet odio.
          </p>
        </li>
        <li className="mb-4">
          <h3 className="text-xl font-bold">Event 4</h3>
          <p className="text-gray-600">
            Vestibulum malesuada eros ut urna placerat, eu elementum erat volutpat.
          </p>
        </li>
        <li className="mb-4">
          <h3 className="text-xl font-bold">Event 5</h3>
          <p className="text-gray-600">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla euismod felis sed mauris tincidunt aliquam.
          </p>
        </li>
        <li className="mb-4">
          <h3 className="text-xl font-bold">Event 6</h3>
          <p className="text-gray-600">
            Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.
          </p>
        </li>
        <li className="mb-4">
          <h3 className="text-xl font-bold">Event 7</h3>
          <p className="text-gray-600">
            Fusce eu justo nec metus fringilla tincidunt a sit amet odio.
          </p>
        </li>
        <li className="mb-4">
          <h3 className="text-xl font-bold">Event 8</h3>
          <p className="text-gray-600">
            Vestibulum malesuada eros ut urna placerat, eu elementum erat volutpat.
          </p>
        </li>
        <li className="mb-4">
          <h3 className="text-xl font-bold">Event 9</h3>
          <p className="text-gray-600">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla euismod felis sed mauris tincidunt aliquam.
          </p>
        </li>
        <li className="mb-4">
          <h3 className="text-xl font-bold">Event 10</h3>
          <p className="text-gray-600">
            Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.
          </p>
        </li>
      </ul>
    </div>
  );
}

export default Events;
